// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"050d10d8","171":"46ace999","176":"33cba922","180":"53bb2daf","301":"dde8d663","435":"3f8db525","521":"c4d0db16","743":"57f1bc34","780":"c580d473","785":"91f136e2","875":"a7f180a6"}[chunkId] + ".chunk.js";
};